import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import EarthquakeStudio from "@/pages/EarthquakeStudio";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<EarthquakeStudio />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
